import { get } from "lodash";

export default order => get(order, "values.eb_last_synced_at");
